import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.4,
    }

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options)

    this.linkTargets.forEach(link => {
      const href = link.getAttribute("href")
      const section = document.querySelector(href)
      if (section) {
        this.observer.observe(section)
      }
    })
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.getAttribute("id")
        this.activateLink(`#${id}`)
      }
    })
  }

  activateLink(id) {
    this.linkTargets.forEach(link => {
      if (link.getAttribute("href") === id) {
        link.classList.add("text-indigo-900", "font-semibold")
        link.classList.remove("hover:text-indigo-800")
      } else {
        link.classList.remove("text-indigo-900", "font-semibold")
        link.classList.add("hover:text-indigo-800")
      }
    })
  }
}
